// ======================= Imports =======================
import { api } from "../../../../utility/AxiosInceptor";
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toast } from "primereact/toast";
import { Loginbg, Sniptel } from "../../../../utility";
import { useNavigate, useSearchParams } from "react-router-dom";

// ======================= Main Component =======================
const ForgotPass = () => {
  // ======================= Refs =======================
  const toast = useRef(null);

  // ======================= Router =======================
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const passToken = searchParams.get("token");

  // ======================= State Management =======================

  const [decodedToken, setDecodedToken] = useState(null);

  // ======================= JWT Decode Utility =======================
  const decodeJWT = (token) => {
    const [, payload] = token.split(".");
    const base64Url = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(
      Buffer.from(base64Url, "base64").toString("utf8")
    );
    return decodedPayload;
  };

  // ======================= Decode Token on Mount =======================
  useEffect(() => {
    if (passToken) {
      const token = passToken.toString();
      const decoded = decodeJWT(token);
      setDecodedToken(decoded);
    }
  }, [passToken]);

  // ======================= Formik Setup =======================
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Password doesn't match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      // ======================= Prepare Data =======================
      const dataToSend = {
        email: decodedToken?.email,
        newPassword: formik.values.password,
        reEnterPassword: formik.values.confirmPassword,
      };

      // ======================= API Call: Reset Password =======================
      api
        .post(`/api/web/user/resetPassword`, dataToSend)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            toast.current.show({
              severity: "success",
              summary: "Reset Password",
              detail: res?.data?.msg,
            });
            navigate("/loginpage");
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Reset Password",
            detail: err?.response?.data?.msg,
          });
        });
    },
  });

  // ======================= Render =======================
  return (
    <div
      className="flex w-full  justify-content-center align-items-center"
      style={{ background: "white", height: "100vh" }}
    >
      <Toast ref={toast} />
      <div className="bggradient flex w-full ">
        <Loginbg />
      </div>
      <form
        onSubmit={formik.handleSubmit}
        className="flex flex-column justify-content-center align-items-center"
        style={{ zIndex: "1", width: "48.3rem", height: "59rem" }}
      >
        <div className="mb-6">
          <span>
            <Sniptel />
          </span>
        </div>
        <div className="flex flex-column justify-content-start align-items-center resetpass">
          <div style={{ width: "35.5rem", zIndex: "1" }}>
            <h1>Create a New Password</h1>
            <p className="flex mt-4">
              Enter a strong password to secure your account.
            </p>
          </div>
          <div
            className="flex flex-column"
            style={{ width: "35.5rem", marginTop: "-3.8rem" }}
          >
            {/* ======================= Password Field ======================= */}
            <div className="flex justify-content-between">
              <label
                className={
                  formik.touched.password && formik.errors.password
                    ? "emaillabelerr"
                    : "emaillabel "
                }
                style={{ marginTop: "5rem" }}
              >
                Password
              </label>
              {formik.touched.password && formik.errors.password ? (
                <span className="err" style={{ marginTop: "5rem" }}>
                  {formik.errors.password}
                </span>
              ) : (
                ""
              )}
            </div>
            <InputText
              id="password"
              name="password"
              className={
                formik.touched.password && formik.errors.password
                  ? "emailinputerr mt-2"
                  : "emailinput mt-2"
              }
              placeholder="Enter your password"
              value={formik.values.password}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {/* ======================= Confirm Password Field ======================= */}
            <div className="flex justify-content-between">
              <label
                className={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                    ? "emaillabelerr mt-5"
                    : "emaillabel mt-5"
                }
              >
                Confirm Password
              </label>
              {formik.touched.confirmPassword &&
              formik.errors.confirmPassword ? (
                <span className="err" style={{ marginTop: "3rem" }}>
                  {formik.errors.confirmPassword}
                </span>
              ) : (
                ""
              )}
            </div>
            <InputText
              id="confirmPassword"
              name="confirmPassword"
              className={
                formik.touched.confirmPassword && formik.errors.confirmPassword
                  ? "emailinputerr mt-2 "
                  : "emailinput mt-2"
              }
              placeholder="Re-enter your password"
              value={formik.values.confirmPassword}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {/* ======================= Submit Button ======================= */}
            <div className="flex w-full" style={{ marginTop: "2.8rem" }}>
              <Button
                type="submit"
                disabled={
                  formik.values.password === "" || formik.errors.confirmPassword
                    ? true
                    : false
                }
                className="forgetbtn"
                label="Reset Password"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ForgotPass;
